var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    clipPath: "url(#pencil_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.71 2.908-6.63 7.02c-.251.266-.493.79-.542 1.154L3.24 13.7c-.105.945.574 1.591 1.51 1.43l2.601-.444c.364-.065.873-.332 1.123-.606l6.631-7.019c1.147-1.212 1.664-2.593-.12-4.28-1.778-1.673-3.127-1.083-4.274.128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.604 4.08a4.95 4.95 0 0 0 4.401 4.159M2.422 17.769H16.96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pencil_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19.385v19.385H0z"
  })))));
};
export default SvgPencil;